import BaseModel from './BaseModel'
import Image from './Image'

export default class CompanyTeamItem extends BaseModel {}

CompanyTeamItem.mapping = {
  image: Image
}
